import React from "react";

import IsRequired from "../../../LeadCompliance/components/Table/IsRequired";
import Report from "./Report";


function Mold({ params, refetchUnits }) {
  const { compliance } = params.row;
  const isRequired = compliance?.visible_mold;

  return compliance?.status == "pending" ? (
    ""
  ) : (
    <IsRequired
      required={isRequired}
      attachment={compliance?.ll55_visible_mold_report}
    >
      <Report
        id={compliance.ll55_id}
        attachment={compliance?.ll55_visible_mold_report}
        refetchUnits={refetchUnits}
        status={"Report-Needed"}
        type={"mold"}
      />
    </IsRequired>
  );
}

export default Mold;
